import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable()
export class AdminSettingsOrdersArchiveService {
  private search_orders$ = new Subject<string>();
  
  listenOrderSearch() {
    return this.search_orders$.asObservable();
  }

  setOrderSearch(search: string) {
    this.search_orders$.next(search);
  }
}